export default {"src":"/_next/static/image/src/onboarding/AccountFeatures/delivery-truck.4ca9ce42a3ffb327bc1d0343d28eda35.svg","height":71,"width":69};